import { render, staticRenderFns } from "./NewRestaurant.vue?vue&type=template&id=016a5458&"
import script from "./NewRestaurant.vue?vue&type=script&lang=js&"
export * from "./NewRestaurant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports